// Quem abre o link da sala sem sessão (item 60): a sala, quem chamou e ENTRAR COM GOOGLE E SENTAR. Na volta do
// Google, o Criar perfil (com o celular) e a pessoa cai direto na sala, sentada no primeiro lugar livre. Se a sala
// encheu nesse meio tempo, a aba Jogar abre com o aviso. O link com ?c=CODIGO guarda a indicação de quem compartilhou.
import { useEffect, useState } from 'react';
import type { SalaNaLista } from '@truco6/mesa/protocolo';
import { AVATARES } from '@truco6/ui';
import { mesaHttp } from '../comum/config.ts';
import { conta } from '../comum/conta.ts';
import { medir } from '../comum/medicao.ts';
import { linkDaSala } from '../comum/rotas.ts';
import { LogoGoogle } from './Entrada.tsx';
import { Tento } from './tentos-comum.tsx';
import { Marca } from '@truco6/ui/Marca';
import { Tela } from './comum.tsx';

export function avatarAoAcaso(): string {
  return AVATARES[Math.floor(Math.random() * AVATARES.length)]!.id;
}

export function Convite({ codigo }: { codigo: string }) {
  const [erro, setErro] = useState<string | null>(null);
  const [ocupado, setOcupado] = useState(false);
  const [sala, setSala] = useState<(SalaNaLista & { donoApelido?: string | null }) | null>(null);
  useEffect(() => {
    fetch(`${mesaHttp}/sala/${codigo}`).then((r) => (r.ok ? r.json() : null)).then((x: { sala: SalaNaLista } | null) => setSala(x?.sala ?? null), () => {});
  }, [codigo]);
  const entrar = () => {
    setErro(null); setOcupado(true);
    medir('login', { method: 'google', origem: 'link_da_sala' });
    // Volta para a mesma sala com o pedido de sentar (vaga=link): o Criar perfil vem antes, se for conta nova.
    conta.entrarComGoogle(linkDaSala(codigo) + '?vaga=link').catch((e: Error) => { setErro(e.message); setOcupado(false); });
  };
  return (
    <Tela>
      <Marca altura={48} />
      <div className="convite">
        <span>{sala ? `Você foi chamado para a ${sala.nome}` : 'Você foi chamado para a mesa'}</span>
        <b>{codigo}</b>
      </div>
      {sala?.ingresso ? (
        <div className="faixa-tentos">
          <Tento tamanho={28} brilho />
          <p><b>Valendo Tentos · {sala.ingresso} por jogador</b><span>Cada vencedor leva {sala.premio}.</span></p>
        </div>
      ) : null}
      <button className="google" disabled={ocupado} onClick={entrar}><LogoGoogle />{ocupado ? 'Um instante...' : 'ENTRAR COM GOOGLE E SENTAR'}</button>
      {erro && <p className="erro" role="alert">{erro}</p>}
      <p className="nota">Cadastro rápido. Você joga 2 partidas grátis por dia e ganha +5 a cada amigo que chamar.</p>
      <p className="nota links-legais">Ao entrar, você aceita os <a href="/termos">Termos de uso</a> e a <a href="/privacidade">Política de privacidade</a>.</p>
    </Tela>
  );
}
